import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "qty-stepper__box" }
const _hoisted_2 = ["disabled", "aria-label"]
const _hoisted_3 = ["value", "min", "max", "step", "disabled", "aria-label"]
const _hoisted_4 = ["disabled", "aria-label"]
const _hoisted_5 = {
  key: 0,
  class: "qty-stepper__caption"
}
const _hoisted_6 = {
  key: 1,
  class: "qty-stepper__caption"
}

import { computed } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { isOrderPack, snapOrderQty } from '@/utils/mallSell'


export default /*@__PURE__*/_defineComponent({
  __name: 'QtyStepper',
  props: {
    modelValue: {},
    min: { default: 1 },
    max: { default: 9999 },
    step: { default: 1 },
    unit: { default: '개' },
    carton: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const stepSize = computed(() => Math.max(1, Math.trunc(Number(props.step) || 1)))
const isPack = computed(() => isOrderPack(stepSize.value))
const unitNoun = computed(() => props.unit || '개')
const shownValue = computed(() =>
  props.carton ? Math.max(1, Math.round(props.modelValue / stepSize.value)) : props.modelValue,
)
const shownMin = computed(() =>
  props.carton ? Math.max(1, Math.round((Number(props.min) || 1) / stepSize.value)) : props.min,
)
const shownMax = computed(() =>
  props.carton
    ? Math.max(shownMin.value, Math.floor((Number(props.max) || shownMin.value) / stepSize.value))
    : props.max,
)
const shownStep = computed(() => (props.carton ? 1 : stepSize.value))
const decLabel = computed(() =>
  props.carton ? '카톤 줄이기' : isPack.value ? `${stepSize.value}${unitNoun.value} 줄이기` : '수량 줄이기',
)
const incLabel = computed(() =>
  props.carton ? '카톤 늘리기' : isPack.value ? `${stepSize.value}${unitNoun.value} 늘리기` : '수량 늘리기',
)

const canDec = computed(() => props.modelValue > Math.max(1, Number(props.min) || 1))
const canInc = computed(() => {
  const next = snap(props.modelValue + stepSize.value)
  return next > props.modelValue
})

function snap(value: number) {
  return snapOrderQty(value, props.min, stepSize.value, props.max)
}

function commit(value: number) {
  if (props.disabled || props.busy) return
  const next = snap(value)
  if (next === props.modelValue) return
  emit('update:modelValue', next)
}

function onCommit(event: Event) {
  if (props.disabled || props.busy) return
  const input = event.target as HTMLInputElement
  const parsed = Number(String(input.value).trim())
  const fallback = Number(props.min) || 1
  const raw = Number.isFinite(parsed) ? (props.carton ? parsed * stepSize.value : parsed) : fallback
  const next = snap(raw)
  if (next === props.modelValue) {
    input.value = String(shownValue.value)
    return
  }
  emit('update:modelValue', next)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["qty-stepper", {
      'is-busy': __props.busy,
      'is-disabled': __props.disabled,
      'qty-stepper--pack': isPack.value,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        disabled: __props.disabled || __props.busy || !canDec.value,
        "aria-label": decLabel.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (commit(__props.modelValue - stepSize.value)))
      }, [
        _createVNode(AppIcon, {
          icon: "mdi-minus",
          size: 16
        })
      ], 8, _hoisted_2),
      _createElementVNode("input", {
        class: "qty-stepper__input",
        type: "number",
        inputmode: "numeric",
        value: shownValue.value,
        min: shownMin.value,
        max: shownMax.value,
        step: shownStep.value,
        disabled: __props.disabled || __props.busy,
        "aria-label": __props.carton ? '카톤 수량' : '수량',
        onChange: onCommit,
        onBlur: onCommit
      }, null, 40, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        disabled: __props.disabled || __props.busy || !canInc.value,
        "aria-label": incLabel.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (commit(__props.modelValue + stepSize.value)))
      }, [
        _createVNode(AppIcon, {
          icon: "mdi-plus",
          size: 16
        })
      ], 8, _hoisted_4)
    ]),
    (__props.carton)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("strong", null, "카톤", -1)
        ]))]))
      : (isPack.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createElementVNode("strong", null, _toDisplayString(stepSize.value.toLocaleString('ko-KR')) + _toDisplayString(unitNoun.value) + "씩", 1)
          ]))
        : _createCommentVNode("", true)
  ], 2))
}
}

})